import React from "react";

export default function InternetInfo() {
  return <div>InternetInfo</div>;
}
